import React, { useState } from 'react';
import { changePassword } from '../api/auth';
import { useToastStore } from '../store/useToastStore';

interface Props {
  onClose: () => void;
}

export default function ChangePasswordModal({ onClose }: Props) {
  const addToast = useToastStore((s) => s.addToast);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('Das neue Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    setSaving(true);
    try {
      await changePassword(oldPassword, newPassword);
      addToast('Passwort erfolgreich geändert.');
      onClose();
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { error?: string } } })?.response?.data?.error ??
        'Fehler beim Ändern des Passworts.';
      setError(msg);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      style={{ background: 'rgba(0,0,0,0.55)' }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 400 }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-semibold">Passwort ändern</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label small fw-semibold" htmlFor="cp-old">Aktuelles Passwort</label>
                <input
                  id="cp-old"
                  type="password"
                  className="form-control"
                  autoFocus
                  autoComplete="current-password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  disabled={saving}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label small fw-semibold" htmlFor="cp-new">Neues Passwort</label>
                <input
                  id="cp-new"
                  type="password"
                  className="form-control"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={saving}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label small fw-semibold" htmlFor="cp-confirm">Passwort bestätigen</label>
                <input
                  id="cp-confirm"
                  type="password"
                  className="form-control"
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={saving}
                  required
                />
              </div>
              {error && <div className="alert alert-danger py-2 small mb-0">{error}</div>}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose}>
                Abbrechen
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-sm"
                disabled={saving || !oldPassword || !newPassword || !confirmPassword}
              >
                {saving ? 'Speichern…' : 'Passwort ändern'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
